export default {
    title: 'Page two',
    'Hi from the second page': 'Hola pagina dos ',
    'Welcome to page 2': 'Welcome to page 2',
    'Go back to the homepage': 'Voltar para a página inicial',
  };
  